module.exports = __webpack_public_path__ + "img/AFL_logo_RU_blue.e3f105c6.svg";